import React, { useEffect, useState, useRef } from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Users, BookOpen, FileText, Star } from 'lucide-react';
import { motion, useInView } from 'framer-motion';
function AnimatedCounter({
  value,
  isDecimal = false
}: {
  value: number;
  isDecimal?: boolean;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000;
      const increment = value / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setCount(value);
          clearInterval(timer);
        } else {
          setCount(start);
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  return <span ref={ref} data-id="element-234">
      {isDecimal ? count.toFixed(1) : Math.floor(count).toLocaleString('es-AR')}
    </span>;
}
export function Stats() {
  const stats = [{
    icon: <Users className="w-6 h-6 md:w-8 md:h-8" data-id="element-235" />,
    prefix: '+',
    value: 1000,
    suffix: '',
    label: 'padres interesados'
  }, {
    icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" data-id="element-236" />,
    value: 50,
    suffix: '',
    label: 'módulos prácticos'
  }, {
    icon: <FileText className="w-6 h-6 md:w-8 md:h-8" data-id="element-237" />,
    value: 1,
    suffix: '',
    label: 'sistema completo'
  }, {
    icon: <Star className="w-6 h-6 md:w-8 md:h-8" data-id="element-238" />,
    value: 4.9,
    isDecimal: true,
    suffix: '/5',
    label: 'valoración ⭐'
  }];
  return <SectionWrapper className="py-8 md:py-16 bg-brand-darkAlt border-y border-slate-800" data-id="element-239">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 text-center" data-id="element-240">
        {stats.map((stat, index) => <div key={index} className="flex flex-col items-center gap-2 md:gap-3" data-id="element-241">
            <div className="text-blue-400 bg-blue-500/15 p-3 md:p-4 rounded-xl md:rounded-2xl" data-id="element-242">
              {stat.icon}
            </div>
            <div data-id="element-243">
              <div className="text-2xl md:text-4xl font-black text-white mb-0.5" data-id="element-244">
                {stat.prefix}
                <AnimatedCounter value={stat.value} isDecimal={stat.isDecimal} data-id="element-245" />
                {stat.suffix}
              </div>
              <div className="text-[10px] md:text-sm text-slate-400 font-medium uppercase tracking-wider" data-id="element-246">
                {stat.label}
              </div>
            </div>
          </div>)}
      </div>
    </SectionWrapper>;
}